"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = (0, _makeStyles.default)(function (theme) {
  return {
    row: {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between"
    },
    value: {
      fontWeight: theme.typography.fontWeightBold
    }
  };
});
var _default = styles;
exports.default = _default;